import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WithRender from './grocery.html';
import { ProductRow, PriceList } from '@/types/ProductTypes';
import VuePhoneNumberInput from 'vue-phone-number-input';
import prdts from '@/settings/products';
import { ProductSettings, ProductData } from '@/types/productSettingTypes';
import { mapGetters } from 'vuex';
import { LocalStorageService } from '@/services/LocalStorageService';

@WithRender
@Component({
  components: {
    Loading,
    VuePhoneNumberInput
  },
  computed: {
    ...mapGetters('originatorStore', { originator: 'getOriginator', currency: 'getWalletCurrency' }),
  }
})
export default class Grocery extends Vue {
  originator!: string;
  priceList: PriceList = {} as PriceList;
  selectedProduct = {} as ProductRow;
  productSetting: ProductSettings = prdts;
  product = {} as ProductData;
  localStorageService = new LocalStorageService();

  pickUpName = '';
  pickUpSurname = '';
  pickUpNumber = '';
  pickUpNumberWithCountryCode = '';

  pickUpNameError = '';
  pickUpSurnameError = '';
  pickUpNumberError = '';

  isLoading = true;

  created() {
    this.product = this.productSetting.products.find(
      x => x.portiFolio == (this.$route.query.portiFolio as string)
        && x.isoCountry == (this.$route.query.c as string)
    ) as ProductData;
  }

  mounted() {
    if (!this.product) {
      this.$router.push({ name: 'Country' });
      return;
    }
    this.getPriceList(this.product.portiFolio);
  }

  private getPriceList(portiFolio: string) {
    this.isLoading = true;
    const dto = {
      portiFolio,
      originator: this.originator,
      parameters: null
    };
    this.$store.dispatch('product/GetPortiFolioOnlyProducts', dto)
      .then(value => {
        this.priceList = value as PriceList;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

  ValidatePickUpNumber(payload: any) {
    this.pickUpNumberWithCountryCode = payload.countryCallingCode + payload.nationalNumber;
    if (payload.isValid) {
      this.pickUpNumberError = '';
    } else {
      this.pickUpNumberError = 'Please enter a valid Zimbabwean mobile number';
    }
  }

  private validate(): boolean {
    let valid = true;

    if (!this.pickUpName.trim()) {
      this.pickUpNameError = 'Pick up name is required';
      valid = false;
    } else {
      this.pickUpNameError = '';
    }

    if (!this.pickUpSurname.trim()) {
      this.pickUpSurnameError = 'Pick up surname is required';
      valid = false;
    } else {
      this.pickUpSurnameError = '';
    }

    if (!this.pickUpNumberWithCountryCode || this.pickUpNumberError) {
      this.pickUpNumberError = 'Please enter a valid Zimbabwean mobile number';
      valid = false;
    }

    return valid;
  }

  CheckOutProduct() {
    if (!this.validate()) return;

    const groceryData = {
      key: this.priceList.key,
      description: this.selectedProduct.description,
      totalAmount: this.selectedProduct.totalAmount,
      salesCurrencyAmount: this.selectedProduct.salesCurrencyAmount,
      reference: (this.selectedProduct as any).reference,
      collectorName: this.pickUpName,
      collectorSurname: this.pickUpSurname,
      collectorNumber: this.pickUpNumberWithCountryCode,
      portiFolio: this.product.portiFolio,
      itemName: this.product.text
    };

    this.localStorageService.add('grocery', JSON.stringify(groceryData));
    this.$router.push('groceryCheckout');
  }
}
